import {
  calculateTicket,
  type BetslipTicket,
} from '@/domain/betslip';

/** Legacy CloseTicketSuccess: restore selections without rewards. */
export function ticketForKeepBets(ticket: BetslipTicket): BetslipTicket {
  const next = structuredClone(ticket) as BetslipTicket & { RewardId?: unknown };
  next.Rewards = [];
  delete next.RewardId;
  return next;
}

/** Remove an entire Custom package from a success snapshot (not the live store). */
export function removeCustomPackageFromTicket(
  ticket: BetslipTicket,
  eventId: string | number,
): BetslipTicket {
  const next = structuredClone(ticket) as BetslipTicket;
  const index = next.Items.findIndex(
    (item) =>
      String(item.Event.EventId) === String(eventId) &&
      item.Bets.some((bet) => bet.Custom === true),
  );
  if (index < 0) return ticket;
  next.Items.splice(index, 1);
  return calculateTicket(next);
}
